import { ApiError, ValidationApiError } from "@anna-money/anna-web-lib/api";
import { extractBackendValidationError } from "helpers/forms/errors";
import { type IAnalyticsManager } from "services/analytics/analyticsManager";
import { FormError } from "types/errors";
import { FormValidationError } from "types/form";

// Create a module-level variable to hold the analytics manager
let _analyticsManager: IAnalyticsManager | null = null;

// Function to set the analytics manager
export function setAnalyticsManager(manager: IAnalyticsManager): void {
  _analyticsManager = manager;
}

function getErrorForAnalytics(error: ValidationApiError | ApiError): string {
  const errorCopy = { ...error };
  errorCopy.diagnostics = {
    ...errorCopy.diagnostics,
    request: { ...errorCopy.diagnostics.request, headers: undefined },
  };
  return JSON.stringify(errorCopy);
}

export function FormSubmitMethod() {
  // todo fix types
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  return (_0: Object, _1: string, descriptor: TypedPropertyDescriptor<any>) => {
    if (typeof descriptor.value === "function") {
      const fn = descriptor.value;
      descriptor.value = async function (...args: unknown[]) {
        try {
          const result = await fn.apply(this, args);
          return result;
        } catch (error) {
          if (error instanceof ValidationApiError) {
            // send validation error to Analytics
            _analyticsManager?.event("server-form-validation-error", {
              errorType: "ValidationApiError",
              component: _0.constructor.name,
              method: _1,
              error: getErrorForAnalytics(error),
            });
            return extractBackendValidationError(error);
          }

          if (error instanceof ApiError || error instanceof FormError) {
            _analyticsManager?.event("server-api-validation-error", {
              errorType: "ApiError",
              component: _0.constructor.name,
              method: _1,
              error: error instanceof FormError ? JSON.stringify(error) : getErrorForAnalytics(error),
            });
            return new FormValidationError(error.message);
          }

          throw error;
        }
      };
    }
  };
}
